/**
 * Tiny ephemeral store that just remembers whether the cart drawer is
 * open. Kept separate from `cartStore` so opening the drawer doesn't
 * touch the persisted cart contents.
 */

import { create } from 'zustand';

interface CartUiState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const useCartUiStore = create<CartUiState>((set, get) => ({
  open: false,
  setOpen: (open) => set({ open }),
  toggle: () => set({ open: !get().open }),
}));
